export default function Footer() {
  return (
    <footer className="simple-footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img
            src="/images/blinkli.png"
            alt="Blinkli"
            className="footer-logo-image"
          />
        </div>

        <div className="footer-copyright">
          <p>
            © {new Date().getFullYear()} Blinkli. All rights reserved. Created by{" "}
            <a href="https://redfrontdoor.com">Redfrontdoor</a>
          </p>
        </div>

        <div className="footer-language">{/* Language switcher would go here if needed */}</div>
      </div>
    </footer>
  )
}
